/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your name`)
};

const es_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe tu nombre`)
};

const de_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihren Namen ein`)
};

const nl_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ uw naam`)
};

const fr_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez votre nom`)
};

const it_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita il tuo nome`)
};

const pt_br2_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite seu nome`)
};

const pt_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva o seu nome`)
};

const ja_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を入力`)
};

const zh_sig_name_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的名字`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_name_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_name_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_name_placeholder", locale)
	if (locale === "en") return en_sig_name_placeholder(inputs)
	if (locale === "es") return es_sig_name_placeholder(inputs)
	if (locale === "de") return de_sig_name_placeholder(inputs)
	if (locale === "nl") return nl_sig_name_placeholder(inputs)
	if (locale === "fr") return fr_sig_name_placeholder(inputs)
	if (locale === "it") return it_sig_name_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_sig_name_placeholder(inputs)
	if (locale === "pt") return pt_sig_name_placeholder(inputs)
	if (locale === "ja") return ja_sig_name_placeholder(inputs)
	return zh_sig_name_placeholder(inputs)
};